import { createContext, useContext } from 'react';

// default js engine version to 1
const CJSEngineVersionContext = createContext<number>(1);

export const CJSEngineVersionProvider = CJSEngineVersionContext.Provider;

export const useCJSEngineVersion = () => useContext(CJSEngineVersionContext);
